import { css } from "styled-components"
import { colors } from "../../helpers/colors"

export const SliderWrapperStyles = css``
export const SlideStyles = css``
export const SlideContentStyles = css``
export const SlideDescriptionStyles = css``
export const PageNumberStyles = css`
  color: ${colors.blue};
`
export const RowStyles = css``
